import { Injector } from '@angular/core';
import { AlertHandlerService } from '@finxone-platform/shared/services';
import { AlertTypes } from '@finxone-platform/shared/sys-config-types';
import { firstValueFrom } from 'rxjs';
import { ConfigService } from '../../../services/config-service/config-service.service';
import { SavingsAccountService } from '../../../services/savings-account-service/savings-account.service';

// DEV/QA/UAT test aid only (see ButtonActionType.DEV_TEST_CLEAR_PISP_INSTITUTION): clears the
// nominated account's institution so the next "Review" click on the deposit page re-triggers the
// real "no institution selected" redirect (reviewPispDeposit) into the institution picker,
// letting testers re-run that flow from scratch - including the VRP-scoped institution list via
// the picker's own `feature` query param handling - without devtools/API access.
export async function devTestClearPispInstitution(injector: Injector): Promise<void> {
  const configService = injector.get(ConfigService);
  const alertHandlerService = injector.get(AlertHandlerService);

  // No-op outside the GoCardless sandbox, so this can never do anything if left on a real
  // client's live project by accident.
  if (configService.config.goCardlessEnvironment !== 'sandbox') {
    alertHandlerService.showAlertFn(
      AlertTypes.ERROR,
      'DEV TEST action is only available in the GoCardless sandbox environment',
    );
    return;
  }

  const savingsAccountService = injector.get(SavingsAccountService);
  try {
    await firstValueFrom(savingsAccountService.setPispInstituionOnNomiantedAccount(null));
    alertHandlerService.showAlertFn(AlertTypes.SUCCESS, 'DEV TEST: institution cleared');
  } catch (error) {
    console.error('DEV TEST: failed to clear institution', error);
    alertHandlerService.showAlertFn(AlertTypes.ERROR, 'DEV TEST: failed to clear institution');
  }
}
